import React from 'react';
import { FieldErrors, UseFormReturn } from 'react-hook-form';
import { useUpdateVirtualMedicine } from '../../../../apis/virtual-medicines/hooks/useUpdateVirtualMedicine';
import { HealtheraButton } from '../../../../healtheraComponents';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';
import { enqueueSnackbar } from 'notistack';
import { useHistory } from 'react-router';

interface Props {
  id: string;
  form: UseFormReturn<VirtualMedicine>;
}

const SaveVirtualMedicine = ({ id, form }: Props) => {
  const history = useHistory();
  const { updateVirtualMedicine, isLoading } = useUpdateVirtualMedicine();

  const handleSave = async (masterMedicine: VirtualMedicine) => {
    await updateVirtualMedicine(id, masterMedicine);
    informAboutSuccess();
    history.goBack();
  };

  const handleInvalidForm = (errors: FieldErrors<VirtualMedicine>) => {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
  };

  return (
    <HealtheraButton disabled={isLoading} onClick={form.handleSubmit(handleSave, handleInvalidForm)}>
      Save
    </HealtheraButton>
  );
};

function informAboutSuccess() {
  enqueueSnackbar('Virtual medicine saved', { variant: 'success' });
}

export default SaveVirtualMedicine;
